﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { ITimeZoneData } from "../../MainSite";
import { DownloadTree } from "./DownloadTree";
import { PlottingPage } from "./PlottingPage";

export class DownloadDialog {
    constructor(private parameterSchemaStation: ParameterSchemaStation, private plottingPage: PlottingPage) {
    }

    private modal: JQuery = null;

    private from: moment.Moment;
    private to: moment.Moment;
    private momentFormatDebug: string = "YYYY-MM-DD HH:mm:ss ZZ (X)";
    private maxParamsAllowed: number = 50;

    private downloadTree: DownloadTree;

    private getMoments(fromYMD: string, toYMD: string): { from: moment.Moment, to: moment.Moment, debug: { f: string, t: string } } {
        let offset: string = this.plottingPage.mainSite.getTimeZoneStringFormat('ZZ');
        let format: string = "YYYY-MM-DD HH:mm:ssZ";

        let f: moment.Moment = moment.parseZone(fromYMD + " 00:00:00" + offset, format);
        let t: moment.Moment = moment.parseZone(toYMD + " 23:59:00" + offset, format);

        return {
            from: f,
            to: t,
            debug: {
                f: f.format(this.momentFormatDebug),
                t: t.format(this.momentFormatDebug)
            }
        }
    }

    public show(defaultFrom: moment.Moment, defaultTo: moment.Moment): void {
        let mm = this.getMoments(defaultFrom.format("YYYY-MM-DD"), defaultTo.format("YYYY-MM-DD"));
        this.from = mm.from;
        this.to = mm.to;
        //console.info("DATERANGE [show]", { aa: mm, args: { f: defaultFrom, t: defaultTo }, from: this.from, from_fmt: this.from.format(this.momentFormatDebug), to: this.to, to_fmt: this.to.format(this.momentFormatDebug) });

        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalContent = $('<div class="modal-content"></div>')
            .appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));

        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);
        let titleStr = "Download Data";
        if (this.parameterSchemaStation) {
            titleStr += `: ${this.parameterSchemaStation.Station.Label}`;
        }
        $('<h4 class="modal-title"></h4>').text(titleStr).appendTo(modalHeader);

        var modalBody = $('<div class="modal-body" id="midi_PlottingPage_modal_download_body"></div>').appendTo(modalContent);

        var timeZoneString = this.plottingPage.mainSite.getTimeZoneString();

        var form = $('<form class="form-horizontal"></form>').appendTo(modalBody);

        let $row: JQuery = null;
        $row = $('<div>').addClass('form-group').appendTo(form);
        $('<label class="col-sm-2 control-label">Date&nbsp;Range</label>').appendTo($row);

        var dateRangePicker = $('<div id="midi_PlottingPage_download_modal_date_container" class="input-daterange input-group"><input class="input-sm form-control" type="text" id="midi_PlottingPage_download_date_picker_from" name="start"><span class="input-group-addon">to</span><input class="input-sm form-control" type="text" id="midi_PlottingPage_download_date_picker_to" name="end"></div>')
            .appendTo($('<div class="col-sm-6"></div>').appendTo($row))
            .datepicker({
                // format: "yyyy-mm-dd  " + timeZoneString,
                format: "yyyy-mm-dd"// ,
                // language: 'pt-BR'
            })
            .on('changeDate', (e) => {
                let ymdFrom: string = dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').val().substr(0, 10);
                let ymdTo: string = dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').val().substr(0, 10);

                let mm = this.getMoments(ymdFrom, ymdTo);
                this.from = mm.from;
                this.to = mm.to;

                /*
                let f2: moment.Moment = moment.utc(dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').val(), 'YYYY-MM-DD');
                let t2: moment.Moment = moment.utc(dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').val(), 'YYYY-MM-DD').endOf('day').startOf('minute');

                console.info("DATERANGE [change]", { aa: mm, from: this.from, from_fmt: this.from.format(this.momentFormatDebug), to: this.to, to_fmt: this.to.format(this.momentFormatDebug), from_val: dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').val(), to_val: dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').val(), utc_from: f2, utc_from_fmt: f2.format(this.momentFormatDebug), utc_to: t2, utc_to_fmt: t2.format(this.momentFormatDebug) });
                */

                //: auto-hide datepicker & move onto 'to' field if appropriate
                $(e.target).blur();
                $(e.target).datepicker('hide');
                if (e.target.id == "midi_PlottingPage_download_date_picker_from") {
                    dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').focus();
                }
            });

        let $tzSelect: JQuery = $("<select>").addClass('form-control input-sm');
        $tzSelect.appendTo($('<div>').addClass('col-sm-4').appendTo($row));

        let tzOpts: ITimeZoneData[] = this.plottingPage.mainSite.getAllAvailableTimeZones();
        let $opt: JQuery = null;
        tzOpts.forEach(tzd => {
            $opt = $('<option>').attr('value', tzd.timeZoneName).text(tzd.label).data('tzOffsetMinutes', tzd.offsetMinutes).data('tzd', tzd);
            $tzSelect.append($opt);
        });
        $tzSelect.val(this.plottingPage.mainSite.getTimeZoneName());

        var dataFormatContainer = $('<div class="form-group"><label class="col-sm-2 control-label">Format</label></div>').appendTo(form);

        var csvDownloadToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataFormatContainer);
        var csvToggle = $('<input type="radio" name= "download_format" checked />').appendTo(csvDownloadToggleContainer);
        $($.parseHTML(' CSV')).appendTo(csvDownloadToggleContainer);

        

        var dlpDownloadToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataFormatContainer);
        var dlpToggle = $('<input type="radio" name= "download_format" />').appendTo(dlpDownloadToggleContainer);
        $($.parseHTML(' DLP')).appendTo(dlpDownloadToggleContainer);

        csvToggle.prop('checked', true);

        var dataIntervalContainer = $('<div class="form-group"><label class="col-sm-2 control-label">Interval</label></div>').appendTo(form);

        var oneMinIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var oneMinInterval = $('<input type="radio" name= "download_interval" />').appendTo(oneMinIntervalToggleContainer);
        $($.parseHTML(' 1 Min.')).appendTo(oneMinIntervalToggleContainer);

        var tenMinIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var tenMinInterval = $('<input type="radio" name= "download_interval" checked />').appendTo(tenMinIntervalToggleContainer);
        $($.parseHTML(' 10 Min.')).appendTo(tenMinIntervalToggleContainer);

        var oneHourIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var oneHourInterval = $('<input type="radio" name= "download_interval" />').appendTo(oneHourIntervalToggleContainer);
        $($.parseHTML(' 1 Hour')).appendTo(oneHourIntervalToggleContainer);

        var allDataIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var allDataInterval = $('<input type="radio" name= "download_interval" />').appendTo(allDataIntervalToggleContainer);
        $($.parseHTML(' All Data')).appendTo(allDataIntervalToggleContainer);

        dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').datepicker('update', mm.from.format("YYYY-MM-DD"));
        dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').datepicker('update', mm.to.format("YYYY-MM-DD"));
        dateRangePicker.datepicker('updateDates');

        var dataParameterContainer = $('<div class="form-group"><label class="col-sm-2 control-label">Parameters</label></div>').appendTo(form);
        var dataParameterTreeContainer = $('<div class="col-sm-10"></div>').appendTo(dataParameterContainer);

        this.downloadTree = new DownloadTree(this.parameterSchemaStation, this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema, dataParameterTreeContainer, this.plottingPage);
        // this.downloadTree.tree.appendTo(dataParameterTreeContainer);

        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooter);
        $('<button type="button" class="btn btn-success">Download</button>')
            .appendTo(modalFooter)
            .click(() => {
                $(".midi_PlottingPage_warningBox").remove();
                var downloadFormat = "";
                if (csvToggle.is(':checked')) {
                    downloadFormat = "csv"
                }
                if (dlpToggle.is(':checked')) {
                    downloadFormat = "dlp"
                }
                var downloadInterval = 0; // default to all data
                if (oneMinInterval.is(':checked')) {
                    downloadInterval = 1;
                }
                if (tenMinInterval.is(':checked')) {
                    downloadInterval = 10;
                }
                if (oneHourInterval.is(':checked')) {
                    downloadInterval = 60;
                }

                $(".midi_PlottingPage_download_inputs").remove();

                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.from.valueOf() + '" name="From">').appendTo(modalForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.to.valueOf() + '" name="To">').appendTo(modalForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + downloadFormat + '" name="Format">').appendTo(modalForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + downloadInterval + '" name="Interval">').appendTo(modalForm);
                // $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.plottingPage.mainSite.getTimeZoneUtcOffset().toString() + '" name="TzDiffMinutes">').appendTo(modalForm);
                // $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.plottingPage.mainSite.getTimeZoneName() + '" name="TzName">').appendTo(modalForm);
                let $tzOpt: JQuery = $tzSelect.find(`option[value="${$tzSelect.val()}"]`);
                if (!$tzOpt || $tzOpt.length == 0) {
                    $('<div class="alert alert-danger midi_PlottingPage_warningBox">Unable to get the timezone option. Please try another timezone or refresh the page.</div>').appendTo(form);
                    return;
                }
                let tzd: ITimeZoneData = <ITimeZoneData>$tzOpt.data('tzd');
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + tzd.offsetMinutes + '" name="TzDiffMinutes">').appendTo(modalForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + tzd.timeZoneName + '" name="TzName">').appendTo(modalForm);

                // console.info("FORM TZ DATA:", { $opt: $opt, tzd: tzd, val: $tzSelect.val() }); // return;

                var selectedNodes = this.downloadTree.fancyTree.getSelectedNodes();
                if (selectedNodes.filter(x => x.data.sensorNode).length > this.maxParamsAllowed) {
                    $(`<div class="alert alert-danger midi_PlottingPage_warningBox">Error downloading data: Please select a maximum of ${this.maxParamsAllowed} parameters.</div>`).appendTo(form);
                    return;
                }

                var anyInputs = false;
                let inputsCount: number = 0;
                selectedNodes.forEach((selectedNode: any) => {
                    if (selectedNode.data.sensorNode) {
                        anyInputs = true;
                        inputsCount++;
                        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.parameterInfo.Store + '" name="StoreCols[]">').appendTo(modalForm);
                        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.sensorNode.stationNode.station.Station.Id + '" name="SiteCols[]">').appendTo(modalForm);
                        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.sensorNode.sensorId + '" name="SensorCols[]">').appendTo(modalForm);
                        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.parameterId + '" name="ParameterCols[]">').appendTo(modalForm);
                        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + (selectedNode.data.variantName === null ? 'undefined' : selectedNode.data.variantName) + '" name="VariantCols[]">').appendTo(modalForm); //: NB: the server does not understand variant "null", but does interpret variant "undefined".
                    }
                });

                if (anyInputs) {
                    if (inputsCount > this.maxParamsAllowed) {
                        $(`<div class="alert alert-danger midi_PlottingPage_warningBox">Error downloading data: Please select a maximum of ${this.maxParamsAllowed} parameters.</div>`).appendTo(form);
                    } else {
                        modalForm.submit();
                        modalForm.empty;
                        this.modal.modal('hide');
                    }
                } else {
                    $('<div class="alert alert-danger midi_PlottingPage_warningBox">Error downloading data: Please select at least one parameter</div>').appendTo(form);
                }
            
            });
        var modalForm = $('<form method="post" action="api/HistoricalData/Get" enctype="application/x-www-form-urlencoded"></form>').appendTo(modalFooter);

        this.modal.on("shown.bs.modal", (e) => {
            this.plottingPage.pageUnblock();
        });
        this.modal.modal('show');
    }


    public hide(): void {
        if (this.modal) {
            this.modal.remove();
        }
    }
}

 